import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IUserProfile } from '@account-users';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() profile: IUserProfile;
  @Input() isAuthenticated: boolean;
  @Output() login = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  onLogin() {
    this.login.emit();
  }

  onLogout() {
    this.logout.emit();
  }
}
